// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderBy_wrapper__sMTE7","over":"OrderBy_over__dv+la","list":"OrderBy_list__pps5t"};